import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { getFormValues } from "redux-form";
import cx from "classnames";
import _ from "lodash";

import { FORM_NAME as sexAndAgeFormName } from "modules/general-info/sex-and-age-form";
import { getPainZonesByView } from "modules/diagnostic/diagnostic-selectors";
import { getUserSex } from "modules/user/user-selectors";
import {
  DiagnosticViews,
  DiagnosticView
} from "modules/diagnostic/diagnostic-constants";

import BodyImage from "modules/pain-profile/body-image";
import { getLocaleSpecificProp } from "modules/i18n/locale-utils";

const getSexFormValues = getFormValues(sexAndAgeFormName);

class BodyModel extends Component {
  static propTypes = {
    painZones: PropTypes.object,
    question: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    sex: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    values: PropTypes.array.isRequired
  };

  state = {
    scale: 1,
    width: 0,
    height: 0,
    selected: [],
    side: DiagnosticView.FRONT
  };

  constructor(props) {
    super(props);

    this.bodyImage = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("resize", this.onWindowResize);
    window.addEventListener("orientationchange", this.onOrientationChange);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
    window.removeEventListener("orientationchange", this.onOrientationChange);
  }

  onWindowResize = () => {
    this.calculateSizeParametersThrottled();
  };

  onOrientationChange = () => {
    if (this.bodyImage.current) {
      // This is trick for updating body size after changing orientation.
      // It is positioned wrong by default.
      this.bodyImage.current.style.width = "100%";

      setTimeout(() => {
        this.bodyImage.current.style.width = "";
        this.calculateSizeParameters();
      }, 1000);
    }
  };

  changeSide = () => {
    this.setState({
      side:
        DiagnosticViews[
          (DiagnosticViews.indexOf(this.state.side) + 1) %
            DiagnosticViews.length
        ]
    });
  };

  getPoints(coords, scale) {
    return coords
      .map(
        ({ lat, lng }) =>
          `${parseFloat(lat) * scale},${parseFloat(lng) * scale}`
      )
      .join(" ");
  }

  onImageLoad = () => {
    this.calculateSizeParameters();
  };

  calculateSizeParameters = () => {
    this.setState({
      width: this.bodyImage.current.width,
      height: this.bodyImage.current.height,
      scale: this.bodyImage.current.width / this.bodyImage.current.naturalWidth
    });
  };

  calculateSizeParametersThrottled = _.throttle(
    this.calculateSizeParameters,
    1000
  );

  renderZones() {
    if (!this.props.painZones) {
      return null;
    }

    const painZones = this.props.painZones[this.state.side];
    return (
      <svg
        className="BodyModel__Zones"
        width={this.state.width}
        height={this.state.height}
      >
        {painZones.map(zone => (
          <polygon
            key={zone.id}
            className={this.props.values.includes(zone.id) ? "selected" : ""}
            onClick={() => this.props.onChange(zone.id)}
            points={this.getPoints(
              zone.coordinates[this.state.side][this.props.sex],
              this.state.scale
            )}
          />
        ))}
      </svg>
    );
  }

  render() {
    const {
      question,
      intl: { locale }
    } = this.props;

    return (
      <div className="QuestionForm-answer-humanModel">
        <div className="QuestionForm-humanModelControl">
          <button
            type="button"
            className={cx("Button--rotate", this.state.side)}
            onClick={this.changeSide}
          />
          <span>
            <FormattedMessage id="body-model.rotate" />
          </span>
        </div>
        <h2>{getLocaleSpecificProp(question, locale)}</h2>
        <div className="BodyModel">
          <div className="BodyModel__Inner">
            <img
              className="BodyModel__Image"
              alt="Body"
              src={BodyImage[this.props.sex][this.state.side]}
              onLoad={this.onImageLoad}
              ref={this.bodyImage}
            />
            {this.renderZones()}
          </div>
        </div>
        <svg className="BodyModel__Filters">
          <defs>
            <filter id="blur" colorInterpolationFilters="sRGB">
              <feGaussianBlur stdDeviation="1" edgeMode="wrap" />
            </filter>
          </defs>
        </svg>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const sexFormValues = getSexFormValues(state);

  return {
    painZones: getPainZonesByView(state),
    sex: (sexFormValues && sexFormValues.sex) || getUserSex(state) || "male"
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BodyModel)
);



// WEBPACK FOOTER //
// ./src/modules/pain-profile/body-model.js